export default "__VITE_ASSET__Do0xZGMZ__"